// extracted by mini-css-extract-plugin
export default {"container":"EditCard_container__gQWoJ","title":"EditCard_title__cLizC"};